import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

/** Enveloppe mobile — plein écran, sans barre suite (logo / coffre / thème). */
export function MobileAppShell({ children }: Props) {
  return (
    <div className="mobile-root flex h-full min-h-0 flex-col">
      <div className="min-h-0 flex flex-1 flex-col">{children}</div>
    </div>
  );
}
